import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faNewspaper } from "@fortawesome/free-regular-svg-icons";
import * as styles from "./css/Footer.module.scss";
import { Trans } from "react-i18next";
import { goTo } from "../utilities/utils";
import { useSelector } from "react-redux";
import { RootState } from "../redux/reducers/rootReducer";

const Footer: React.FC = () => {
  let routeDetails = useSelector((state: RootState) => {
    return state.route;
  });

  return (
    <div className={styles.footerContainer}>
      <div className="container">
        <img
          src="/images/phonebox-logo.png"
          width="152px"
          alt="Phone box Logo with text"
          className={styles.logoImage}
        />
        <div className={styles.innerContainer}>
          <div>
            <h4>
              <Trans>About PhoneBox</Trans>
            </h4>
            <ul className={styles.ulList}>
              <li>
                <a
                  href="/about-us"
                  onClick={(event) => {
                    event.preventDefault();
                    goTo("/about-us");
                  }}
                >
                  <Trans>About Us</Trans>
                </a>
              </li>
              <li>
                <a
                  href="/careers"
                  onClick={(event) => {
                    event.preventDefault();
                    goTo("/careers");
                  }}
                >
                  <Trans>Careers</Trans>
                </a>
              </li>
              <li>
                <a
                  href="/support"
                  onClick={(event) => {
                    event.preventDefault();
                    goTo("/support#contact-us");
                  }}
                >
                  <Trans>Contact Us</Trans>
                </a>
              </li>
              <li>
                <a
                  href="/site-map"
                  onClick={(event) => {
                    event.preventDefault();
                    goTo("/site-map");
                  }}
                >
                  <Trans>Site Map</Trans>
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4>
              <Trans>Policies</Trans>
            </h4>
            <ul className={styles.ulList}>
              <li>
                <a
                  href="/terms-of-service"
                  onClick={(event) => {
                    event.preventDefault();
                    goTo("/terms-of-service");
                  }}
                >
                  <Trans>Terms of Service</Trans>
                </a>
              </li>
              <li>
                <a
                  href={`/terms-of-service/${
                    routeDetails.routeString === "terms-of-service"
                      ? ""
                      : "?section=early-cancellation"
                  }`}
                  onClick={(event) => {
                    event.preventDefault();
                    goTo(
                      `/terms-of-service/${
                        routeDetails.routeString === "terms-of-service"
                          ? ""
                          : "?section=early-cancellation"
                      }`
                    );
                  }}
                >
                  <Trans>Return & Refund</Trans>
                </a>
              </li>
              {/* newly added 1 */}
              <li>
                <a
                  href={"/privacy-policy"}
                  onClick={(event) => {
                    event.preventDefault();
                    goTo("/privacy-policy");
                  }}
                >
                  <Trans>Privacy Policy & Accessibility Plan</Trans>
                </a>
              </li>
              {/* newly added 2  */}
              <li>
                <a
                  href={"/cookie-and-cache-policy"}
                  onClick={(event) => {
                    event.preventDefault();
                    goTo("/cookie-and-cache-policy");
                  }}
                >
                  <Trans>Cookie & Cache Policy</Trans>
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4>
              <Trans>Customer Support</Trans>
            </h4>
            <ul className={styles.ulList}>
              <li>
                <a
                  href="/support"
                  onClick={(event) => {
                    event.preventDefault();
                    goTo("/support");
                  }}
                >
                  <Trans>Help Center (FAQs)</Trans>
                </a>
              </li>
              <li>
                <a href="https://myaccount.gophonebox.com/">
                  <Trans>Pay your Bill</Trans>
                </a>
              </li>
              <li>
                <a
                  href="/apn-setting"
                  onClick={(event) => {
                    event.preventDefault();
                    goTo("/apn-setting");
                  }}
                >
                  <Trans>APN Settings</Trans>
                </a>
              </li>
              <li>
                <a
                  href="/coverage-map"
                  onClick={(event) => {
                    event.preventDefault();
                    goTo("/coverage-map");
                  }}
                >
                  <Trans>Coverage Map</Trans>
                </a>
              </li>
              <li>
                <a
                  href="https://crtc.gc.ca/eng/phone/mobile/prepay.htm"
                  target="_blank"
                >
                  <Trans>CRTC code - Wireless</Trans>
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4>
              <Trans>Social Media</Trans>
            </h4>
            <ul className={styles.ulList}>
              <li>
                <a href="https://blog.gophonebox.com/" target="_blank">
                  <FontAwesomeIcon icon={faNewspaper} /> &nbsp;
                  <Trans>Blog</Trans>
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/gophonebox" target="_blank">
                  <FontAwesomeIcon icon={faFacebook} /> &nbsp;
                  <Trans>Facebook</Trans>
                </a>
              </li>
              <li>
                <a href="https://twitter.com/gophonebox" target="_blank">
                  <FontAwesomeIcon icon={faTwitter} /> &nbsp;
                  <Trans>Twitter</Trans>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/gophonebox/" target="_blank">
                  <FontAwesomeIcon icon={faInstagram} /> &nbsp;
                  <Trans>Instagram (Canada)</Trans>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/phoneboxusa/"
                  target="_blank"
                >
                  <FontAwesomeIcon icon={faInstagram} /> &nbsp;
                  <Trans>Instagram (USA)</Trans>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <hr />
        <div>
          <h4 className={styles.downloadOurAppHeading}>
            <Trans>Download our App!</Trans>
          </h4>
          <div className={styles.downloadContainer}>
            <div className={styles.innerDownloadContainer}>
              <p>Canada:</p>
              <div>
                <a
                  href="https://play.google.com/store/apps/details?id=com.phoneboxexpo.SelfServe2024"
                  target="_blank"
                >
                  <img src="/images/google-play-logo.png" />
                </a>
                <a
                  href="https://apps.apple.com/ca/app/phonebox-canada/id6503991715?platform=iphone"
                  target="_blank"
                >
                  <img src="/images/app-store-png.png" />
                </a>
              </div>
            </div>
            <div className={styles.innerDownloadContainer}>
              <p>USA:</p>
              <div>
                <a
                  href="https://play.google.com/store/apps/details?id=com.phoneboxexpo.phoneboxfrontend"
                  target="_blank"
                >
                  <img src="/images/google-play-logo.png" />
                </a>
                <a
                  href="https://apps.apple.com/us/app/phonebox-us/id6446149914?platform=iphone"
                  target="_blank"
                >
                  <img src="/images/app-store-png.png" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className={styles.footerYear}>
          &copy; {new Date().getFullYear()}{" "}
          <Trans>
            Connex&nbsp;Global&nbsp;Communications&nbsp;Inc. o/a PhoneBox. All
            Rights Reserved.
          </Trans>
        </div>
      </div>
    </div>
  );
};
export default Footer;
